<div class="shared-calendar" *transloco="let t; prefix: 'assetShared.calendar'">
  <div class="shared-calendar__header">
    <div class="header-left">
      @if (config.backLink) {
        <a class="back-link" [routerLink]="[config.backLink]" [attr.aria-label]="t('back')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
              fill="#9FA1A4" />
          </svg>
        </a>
      }
      <h1 class="header-title">{{ config.title }}</h1>
    </div>

    <div class="header-center">
      <button type="button" class="today-btn" (click)="goToToday()">{{ t('today') }}</button>

      <div class="month-navigation">
        <button type="button" class="nav-btn" (click)="previousMonth()" [attr.aria-label]="t('previous')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <span class="month-label">{{ currentMonthName }}</span>

        <button type="button" class="nav-btn" (click)="nextMonth()" [attr.aria-label]="t('next')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <div ngbDropdown class="year-dropdown">
          <button type="button" class="year-dropdown-btn" ngbDropdownToggle>
            <span class="year-label">{{ currentYear }}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="year-dropdown-icon" aria-hidden="true">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <div ngbDropdownMenu class="year-dropdown-menu">
            @for (year of availableYears; track year) {
              <button type="button" ngbDropdownItem [class.active]="year === currentYear" (click)="selectYear(year)">
                {{ year }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="header-right gap-2">
      <app-search [placeholder]="config.searchPlaceholder || t('searchPlaceholder')" customWidth="300px" (searchTermUpdated)="onSearchChange($event)">
      </app-search>

      <div class="common-drop-down date-height">
        <app-date-filter
          [filter]="dateFilter"
          [isButtonIntervalSelector]="false"
          [disabledIntervals]="disabledIntervals"
          [defaultInterval]="defaultInterval"
          [disableCustomDateSelector]="true"
          (filterChanged)="onDateFilterChange($event)">
        </app-date-filter>
      </div>

      <ng-content select="[headerActions]"></ng-content>
    </div>
  </div>

  <div class="shared-calendar__content">
    <!-- Sidebar -->
    <div class="calendar-sidebar">
      <!-- Mini Calendar -->
      <div class="mini-calendar">
        <div class="mini-calendar__header">
          <button type="button" class="mini-nav-btn" (click)="previousMiniMonth()" [attr.aria-label]="t('previousMonth')">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <span class="mini-month-year">{{ miniCalendarMonthYear }}</span>

          <button type="button" class="mini-nav-btn" (click)="nextMiniMonth()" [attr.aria-label]="t('nextMonth')">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>

        <div class="mini-calendar__weekdays">
          <span>{{ t('miniWeekDays.su') }}</span><span>{{ t('miniWeekDays.mo') }}</span><span>{{ t('miniWeekDays.tu') }}</span><span>{{ t('miniWeekDays.we') }}</span><span>{{ t('miniWeekDays.th') }}</span><span>{{ t('miniWeekDays.fr') }}</span><span>{{ t('miniWeekDays.sa') }}</span>
        </div>

        <div class="mini-calendar__days">
          @for (day of miniCalendarDays; track day.date.toISOString()) {
            <button
              type="button"
              class="mini-day"
              [class.other-month]="!day.isCurrentMonth"
              [class.today]="day.isToday"
              [class.selected]="isSelectedDay(day)"
              (click)="selectMiniDay(day)">
              {{ day.dayNumber }}
            </button>
          }
        </div>
      </div>

      <!-- Today Section -->
      @if (config.showTodaySection !== false) {
        <div class="today-section" [class.is-expanded]="todayExpanded">
          <div class="section-header">
            <span class="section-title">{{ config.todaySectionTitle || t('today') }}</span>

            @if (todayExpanded && todayEvents.length > 1) {
              <button
                type="button"
                class="collapse-btn"
                [attr.aria-label]="t('expandCollapse')"
                (click)="toggleTodayExpanded()"
                [class.is-expanded]="todayExpanded">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            }
          </div>

          @if (isLoadingTodayEvents && todayPage === 1) {
            <div class="today-events today-events--loading">
              <span class="spinner-border spinner-border-sm"></span>
            </div>
          } @else {
            <div
              class="today-events"
              infiniteScroll
              [scrollWindow]="false"
              (scrolled)="onTodayScrolled()"
              [infiniteScrollDistance]="2"
              [infiniteScrollThrottle]="300">
              @for (event of visibleTodayEvents; track event.id) {
                <div class="today-item">
                  <div class="today-item__top">
                    <span class="today-item__icon" aria-hidden="true">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M7 3V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        <path d="M17 3V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        <path d="M4 9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        <path
                          d="M6 5H18C19.1046 5 20 5.89543 20 7V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </span>

                    <span class="today-item__type">{{ getEventTypeLabel(event.type) }}</span>
                    <span class="today-item__dot" [style.background-color]="getTodayEventColor(event)"></span>
                  </div>

                  <div class="today-item__meta">
                    <div class="today-item__time">
                      @if (event.endTime) {
                        {{ event.startTime }} - {{ event.endTime }}
                      } @else {
                        {{ event.startTime }}
                      }
                    </div>
                    <div class="today-item__asset">{{ event.assetName }}</div>
                    @if (event.colorKey) {
                      <div class="today-item__calendar-type">
                        <span class="today-item__calendar-type-dot" [style.background-color]="getFilterColor(event.colorKey)"></span>
                        <span>{{ getFilterLabel(event.colorKey) }}</span>
                      </div>
                    }
                    <div class="today-item__workshop">{{ event.workshop }}</div>
                  </div>
                </div>
              }

              @if (!todayExpanded && todayEvents.length > 1) {
                <button type="button" class="today-more-btn" (click)="toggleTodayExpanded()">{{ t('showMore') }}</button>
              }

              @if (todayExpanded && todayEvents.length > 1) {
                <button type="button" class="today-more-btn" (click)="toggleTodayExpanded()">{{ t('showLess') }}</button>
              }

              @if (todayExpanded && todayPage > 1 && isLoadingTodayEvents) {
                <div class="today-events__loading-more">
                  <span class="spinner-border spinner-border-sm"></span>
                </div>
              }

              @if (todayEvents.length === 0) {
                <div class="no-events">{{ t('noUpcomingEvents') }}</div>
              }
            </div>
          }
        </div>
      }

      <!-- Filter Section (configurable title and options) -->
      @if (config.filterOptions.length > 0) {
        <div class="filter-section">
          <span class="section-title">{{ config.filterSectionTitle }}</span>

          <div class="status-filters">
            @for (option of config.filterOptions; track option.key) {
              <label class="status-filter">
                <input type="checkbox" [checked]="isFilterChecked(option.key)" (change)="onFilterToggle(option)" />
                <span class="checkbox-custom"></span>
                <span class="filter-label">{{ option.label }}</span>
                <span class="filter-dot" [style.background-color]="option.color"></span>
              </label>
            }
          </div>
        </div>
      }

      @for (section of config.filterSections ?? []; track section.key) {
        @if (section.options.length > 0) {
          <div class="filter-section">
            <span class="section-title">{{ section.title }}</span>

            <div class="status-filters">
              @for (option of section.options; track option.key) {
                <label class="status-filter">
                  <input type="checkbox" [checked]="isFilterChecked(option.key)" (change)="onFilterSectionToggle(section, option)" />
                  <span class="checkbox-custom"></span>
                  <span class="filter-label">{{ option.label }}</span>
                  <span class="filter-dot" [style.background-color]="option.color"></span>
                </label>
              }
            </div>
          </div>
        }
      }

      @if (config.missedEventFilter; as missed) {
        <div class="filter-section">
          <span class="section-title">{{ config.missedEventFilterSectionTitle || t('status') }}</span>

          <div class="status-filters">
            <label class="status-filter" [class.status-filter--disabled]="isMissedFilterDisabled()">
              <input
                type="checkbox"
                [checked]="isFilterChecked(missed.key)"
                [disabled]="isMissedFilterDisabled()"
                (change)="onMissedFilterToggle()" />
              <span class="checkbox-custom"></span>
              <span class="filter-label">{{ missed.label }}</span>
              <span class="filter-dot" [style.background-color]="missed.color"></span>
            </label>
          </div>
        </div>
      }
    </div>

    <!-- Main Calendar Area -->
    <div class="calendar-main">
      @if (isLoadingEvents) {
        <div class="calendar-loader">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
      } @else if (selectedView === 'day') {
        <!-- Day View -->
        <div class="calendar-surface day-view">
          <div class="day-view__header">
            <div class="day-view__column-header">
              <span class="day-view__day-name">{{ selectedDayName }}</span>
              <span class="day-view__day-number" [class.day-view__day-number--today]="isSelectedDayToday">
                {{ selectedDayNumber }}
              </span>
            </div>
          </div>

          <div class="day-view__timeline">
            @for (hour of dayViewHours; track hour) {
              <div class="day-view__hour-row">
                <div class="day-view__hour-label">{{ formatHour(hour) }}</div>
                <div class="day-view__hour-content">
                  @for (event of getVisibleEventsForHour(hour); track event.id) {
                    <div
                      class="day-view__event"
                      [class.event-chip--colored]="hasEventBackground(event)"
                      [style.background-color]="getEventBackgroundColor(event)"
                      [style.--event-text-color]="getEventTextColor(event)"
                      [style.--event-status-color]="getEventColor(event)"
                      (click)="onEventClick(event)">
                      <span class="event-dot" [style.background-color]="getEventColor(event)"></span>
                      <span class="event-text">{{ event.startTime }} {{ event.assetName }}</span>
                    </div>
                  }

                  @if (getRemainingEventsForHour(hour) > 0) {
                    <button
                      type="button"
                      class="more-events"
                      #dayHourPopover="ngbPopover"
                      [ngbPopover]="dayHourEventsPopover"
                      [popoverContext]="{ hour: hour, popover: dayHourPopover }"
                      popoverClass="day-events-popover"
                      placement="right"
                      [autoClose]="'outside'">
                      {{ t('showMore') }}
                    </button>
                  }
                </div>
              </div>
            }

            <ng-template #dayHourEventsPopover let-hour="hour" let-popover="popover">
              <div class="events-popover" (click)="$event.stopPropagation()">
                <div class="events-popover__header">
                  <span class="events-popover__title">{{ selectedDayName }} {{ selectedDayNumber }} • {{ formatPopoverHour(hour) }}</span>

                  <button
                    type="button"
                    class="events-popover__close"
                    [attr.aria-label]="t('closePopover')"
                    (click)="popover.close(); $event.stopPropagation()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M16.192 6.34375L11.949 10.5858L7.70697 6.34375L6.29297 7.75775L10.535 11.9998L6.29297 16.2418L7.70697 17.6558L11.949 13.4137L16.192 17.6558L17.606 16.2418L13.364 11.9998L17.606 7.75775L16.192 6.34375Z"
                        fill="#9FA1A4" />
                    </svg>
                  </button>
                </div>

                <div class="events-popover__list">
                  @for (event of getPopoverEventsForHour(hour); track event.id) {
                    <div
                      class="events-popover__item"
                      [class.event-chip--colored]="hasEventBackground(event)"
                      [style.background-color]="getEventBackgroundColor(event)"
                      [style.--event-text-color]="getEventTextColor(event)"
                      [style.--event-status-color]="getEventColor(event)"
                      (click)="popover.close(); onEventClick(event); $event.stopPropagation()">
                      <span class="event-dot" [style.background-color]="getEventColor(event)"></span>
                      <span class="event-text">{{ event.startTime }} {{ event.assetName }}</span>
                    </div>
                  }
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      } @else if (selectedView === 'week') {
        <!-- Week View -->
        <div class="calendar-surface week-view">
          <div class="week-view__header" [style.--week-scrollbar-width.px]="weekTimelineScrollbarWidth">
            <div class="week-view__hour-spacer"></div>
            @for (day of weekViewDays; track day.date.toISOString()) {
              <div class="week-view__day-header" [class.week-view__day-header--today]="isWeekDayToday(day)">
                <span class="week-view__day-name">{{ getWeekDayName(day) }}</span>
                <span class="week-view__day-number" [class.week-view__day-number--today]="isWeekDayToday(day)">
                  {{ day.dayNumber }}
                </span>
              </div>
            }
          </div>

          <div class="week-view__timeline" #weekTimeline>
            @for (hour of dayViewHours; track hour) {
              <div class="week-view__hour-row">
                <div class="week-view__hour-label">{{ formatHour(hour) }}</div>
                <div class="week-view__hour-cells">
                  @for (day of weekViewDays; track day.date.toISOString()) {
                    <div
                      class="week-view__hour-cell"
                      [class.week-view__hour-cell--today]="isWeekDayToday(day)">
                      @for (event of getVisibleEventsForDayAndHour(day, hour); track event.id) {
                        <div
                          class="week-view__event"
                          [class.event-chip--colored]="hasEventBackground(event)"
                          [style.background-color]="getEventBackgroundColor(event)"
                          [style.--event-text-color]="getEventTextColor(event)"
                          [style.--event-status-color]="getEventColor(event)"
                          (click)="onEventClick(event)">
                          <span class="event-dot" [style.background-color]="getEventColor(event)"></span>
                          <span class="event-text">{{ event.startTime }} {{ event.assetName }}</span>
                        </div>
                      }
                      @if (getRemainingEventsForDayAndHour(day, hour) > 0) {
                        <button
                          type="button"
                          class="more-events"
                          #weekHourPopover="ngbPopover"
                          [ngbPopover]="weekHourEventsPopover"
                          [popoverContext]="{ day: day, hour: hour, popover: weekHourPopover }"
                          popoverClass="day-events-popover"
                          placement="auto"
                          [autoClose]="'outside'">
                          {{ t('showMore') }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <ng-template #weekHourEventsPopover let-day="day" let-hour="hour" let-popover="popover">
              <div class="events-popover" (click)="$event.stopPropagation()">
                <div class="events-popover__header">
                  <span class="events-popover__title">{{ formatPopoverDate(day) }} • {{ formatPopoverHour(hour) }}</span>

                  <button
                    type="button"
                    class="events-popover__close"
                    [attr.aria-label]="t('closePopover')"
                    (click)="popover.close(); $event.stopPropagation()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M16.192 6.34375L11.949 10.5858L7.70697 6.34375L6.29297 7.75775L10.535 11.9998L6.29297 16.2418L7.70697 17.6558L11.949 13.4137L16.192 17.6558L17.606 16.2418L13.364 11.9998L17.606 7.75775L16.192 6.34375Z"
                        fill="#9FA1A4" />
                    </svg>
                  </button>
                </div>

                <div class="events-popover__list">
                  @for (event of getPopoverEventsForDayAndHour(day, hour); track event.id) {
                      <div
                        class="events-popover__item"
                        [class.event-chip--colored]="hasEventBackground(event)"
                        [style.background-color]="getEventBackgroundColor(event)"
                        [style.--event-text-color]="getEventTextColor(event)"
                        [style.--event-status-color]="getEventColor(event)"
                        (click)="popover.close(); onEventClick(event); $event.stopPropagation()">
                        <span class="event-dot" [style.background-color]="getEventColor(event)"></span>
                        <span class="event-text">{{ event.startTime }} {{ event.assetName }}</span>
                      </div>
                  }
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      } @else {
        <!-- Month View -->
        <div class="calendar-surface">
          <div class="calendar-weekdays">
            @for (day of weekDays; track day) {
              <div class="weekday-header">{{ day }}</div>
            }
          </div>

          <div
            class="calendar-grid"
            [style.--calendar-rows]="calendarWeekCount"
            [class.calendar-grid--hide-drop-placeholder]="isDraggingOverDisabledDropList"
            cdkDropListGroup>
            @for (day of visibleCalendarDays; track day.date.toISOString()) {
              <div class="calendar-day" [class.other-month]="!day.isCurrentMonth" (click)="selectDay(day)">
                <span
                  class="day-number"
                  [class.day-number--highlight]="day.isToday"
                  [class.day-number--selected]="isSelectedDay(day) && !day.isToday"
                  [class.day-number--muted]="!day.isCurrentMonth">
                  {{ day.dayNumber }}
                </span>

                <div
                  class="day-events"
                  [class.day-events--no-drop]="isDayDropDisabled(day)"
                  (pointerenter)="onDayDropListPointerEnter(day)"
                  (pointerleave)="onDayDropListPointerLeave(day)"
                  cdkDropList
                  [cdkDropListEnterPredicate]="canDropOnList"
                  [cdkDropListSortingDisabled]="shouldDisableDropListSorting(day)"
                  [cdkDropListData]="day.events"
                  [id]="getDropListId(day)"
                  (cdkDropListDropped)="onEventDrop($event, day)">
                  @for (event of getVisibleEvents(day); track event.id) {
                    <div
                      class="event-item"
                      [class.event-chip--colored]="hasEventBackground(event)"
                      [style.background-color]="getEventBackgroundColor(event)"
                      [style.--event-text-color]="getEventTextColor(event)"
                      [style.--event-status-color]="getEventColor(event)"
                      cdkDrag
                      [cdkDragData]="event"
                      (cdkDragStarted)="onCalendarEventDragStarted(event)"
                      (cdkDragEnded)="onCalendarEventDragEnded()">
                      <div class="event-drag-placeholder" *cdkDragPlaceholder></div>
                      <span class="event-dot" [style.background-color]="getEventColor(event)"></span>
                      <span class="event-text" (click)="onEventClick(event); $event.stopPropagation()">
                        {{ event.startTime }} {{ event.assetName }}
                      </span>
                    </div>
                  }

                  @if (getRemainingEventsCount(day) > 0) {
                    <button
                      type="button"
                      class="more-events"
                      #p="ngbPopover"
                      [ngbPopover]="dayEventsPopover"
                      [popoverContext]="{ day: day, popover: p }"
                      popoverClass="day-events-popover"
                      [container]="'body'"
                      placement="auto"
                      [triggers]="'manual'"
                      [autoClose]="'outside'"
                      (click)="onMonthDayExpand(day, p); $event.stopPropagation()">
                      {{ t('showMore') }}
                    </button>

                    <ng-template #dayEventsPopover let-day="day" let-popover="popover">
                      <div class="events-popover" (click)="$event.stopPropagation()">
                        <div class="events-popover__header">
                          <span class="events-popover__title">{{ formatPopoverDate(day) }}</span>

                          <button
                            type="button"
                            class="events-popover__close"
                            [attr.aria-label]="t('closePopover')"
                            (click)="popover.close(); $event.stopPropagation()">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path
                                d="M16.192 6.34375L11.949 10.5858L7.70697 6.34375L6.29297 7.75775L10.535 11.9998L6.29297 16.2418L7.70697 17.6558L11.949 13.4137L16.192 17.6558L17.606 16.2418L13.364 11.9998L17.606 7.75775L16.192 6.34375Z"
                                fill="#9FA1A4" />
                            </svg>
                          </button>
                        </div>

                        <div class="events-popover__list">
                          @if (isExpandedDayLoading(day)) {
                            <div class="events-popover__loading">
                              <span class="spinner-border spinner-border-sm"></span>
                            </div>
                          } @else {
                            @for (event of getPopoverEvents(day); track event.id) {
                              <div
                                class="events-popover__item"
                                [class.event-chip--colored]="hasEventBackground(event)"
                                [style.background-color]="getEventBackgroundColor(event)"
                                [style.--event-text-color]="getEventTextColor(event)"
                                [style.--event-status-color]="getEventColor(event)"
                                (click)="popover.close(); onEventClick(event); $event.stopPropagation()">
                                <span class="event-dot" [style.background-color]="getEventColor(event)"></span>
                                <span class="event-text">{{ event.startTime }} {{ event.assetName }}</span>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </ng-template>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>